import axios from "axios";
import { ETollTypes } from "../component/eToll/ETollTypes";

const ETollActions = () => {
  const baseUrl = ``;

  const getEToll = async (tenant: string, params: any) => {
    return await axios.get(`${baseUrl}/masterdatavehicle/etoll`, {
      params: { tenant, ...params },
    });
  };

  const exportAllETollData = async (params: any) => {
    return await axios.get(`${baseUrl}/masterdatavehicle/etoll/excel`, {
      params: params,
      responseType: "arraybuffer",
      headers: { "Access-Control-Allow-Origin": true },
    });
  };
  const uploadETollFile = async (
    tenant: string,
    languageTag: string,
    file: FormData
  ) => {
    return await axios.post(
      `${baseUrl}/masterdatavehicle/etollimporttracking/file`,
      file,
      {
        params: {
          tenant: tenant,
          languageTag: !!languageTag ? languageTag : null,
        },
      }
    );
  };

  const createEToll = async (
    tenant: string,
    languageTag: string,
    createData: ETollTypes.CreateModal
  ) => {
    return await axios.post(
      `${baseUrl}/masterdatavehicle/etoll`,
      createData,
      {
        params: { tenant: tenant, languageTag: languageTag },
      }
    );
  };

  const downloadTemplate = async () => {
    return axios.get("masterdatavehicle/etollimporttracking/template", {
      responseType: "arraybuffer",
      headers: { "Access-Control-Allow-Origin": true },
    });
  };

  return {
    getEToll: getEToll,
    exportAllETollData: exportAllETollData,
    uploadETollFile: uploadETollFile,
    createEToll: createEToll,
    downloadTemplate,
  };
};

export default ETollActions;
